module.exports = __webpack_public_path__ + "img/img_hula_img3.c5cf3d75.png";